import { ProfileOutlined } from "@ant-design/icons";
import React from "react";
import { ZClassifier } from "src/business/classifier/ZClassifier";
import {
  columnDisplayId,
  sysColumnsHistory,
} from "src/business/sysData/sysColumns";
import { BlankLink } from "src/components/BlankLink/BlankLink";
import { makeMdmActionColumn, RenderLinkAction } from "src/components/MdmTable";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

export const classifierColumns: RtColumn<ZClassifier>[] = [
  columnDisplayId,
  {
    key: "name",
    title: "Название",
    minWidth: 120,
    render: ({ name }) => name,
  },
  {
    key: "description",
    title: "Описание",
    minWidth: 120,
    render: (row) => row.description,
  },
  {
    key: "schemas",
    title: "Первичная спецификация",
    minWidth: 120,
    render: ({ schemas }) => {
      const schema = schemas?.[0];

      return schema ? (
        <BlankLink
          href={makeUrl(PageUrl.managementPrimSpecCard, { id: schema.id })}
          title="Открыть карточку спецификации в новой вкладке"
        >
          {schema.label}
        </BlankLink>
      ) : null;
    },
  },
  ...sysColumnsHistory,
  makeMdmActionColumn<ZClassifier>({
    key: "classes",
    render: ({ id }) => (
      <RenderLinkAction
        icon={<ProfileOutlined />}
        tooltip="Открыть список в новой вкладке"
        href={makeUrl(PageUrl.classes, { id })}
      />
    ),
  }),
];
